import React, {Component, Fragment} from 'react'
import {Form, InputGroup, Button} from "react-bootstrap";

import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import Col from "react-bootstrap/Col";
import {ButtonWithIcon} from "../../../ui/forms/Buttons";

import icnCompare from '../../../../assets/svg/actions/icn-compare.svg';
import icnDelete from "../../../../assets/svg/actions/icn-delete-blue.svg";
import {Link} from "react-router-dom";
import InlineSVG from "react-inlinesvg";
import {connect} from "react-redux";
import {removeSelectedPlayers, setSearchValue} from "../../../../store/actions/Dashboard/Watchlist/WatchlistActions";
import {withApollo} from "@apollo/react-hoc";
import {gql} from "@apollo/client";
import {useMutation} from "@apollo/react-hooks";
import * as Swal from "sweetalert2";
import Tools from '../../../../Tools';
import {FETCH_WATCHLIST_DATATABLE_QUERY} from "./WatchlistDataTable";

import '../../../../assets/sass/pages/scouting/delete-confirm-modal.scss'

import SA_ConfirmDelete from "../../../ui/sweetalert/SA_ConfirmDelete";

library.add(fas, far);

class MainToolbar extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    render = () => {
        const {tempSearch} = this.props;

        return (
            <Form onSubmit={this.handleSubmit} className="toolbar">
                <Form.Row className="row form">
                    <Col className="col-xl-3 col-md-4 col order-1 order-md-0 pr-0 mr-0">
                        <InputGroup className="input-group-white-lg">
                            <Form.Control
                                value={tempSearch}
                                name="text" placeholder="Search Players, Sports clubs, teams...etc" className="input input-white input-lg" onChange={this.handleSearchChange}/>
                            <InputGroup.Append>
                                <InputGroup.Text>
                                    <i className="icon search-icon"/>
                                </InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                    </Col>
                    <Col className="col-xl col-md col-12 mb-3">
                        <div className="h-100 w-100 d-flex align-items-center justify-content-end">
                            {this.renderDeleteButton()}
                            {this.renderCompareButton()}
                        </div>
                    </Col>
                </Form.Row>
            </Form>
        );
    };

    renderDeleteButton = () => {
        const {selectedCount} = this.props;
        const disableCompare = selectedCount === 0;

        return (
            <Button variant="link" size={"lg"} className="delete-watchlist w-auto" disabled={disableCompare} onClick={this.handleDeleteButton}><InlineSVG src={icnDelete}/></Button>
        );
    };

    renderCompareButton = () => {
        const {selectedCount} = this.props;
        const disableCompare = !(selectedCount === 2 || selectedCount === 3);

        var Button = (
            <ButtonWithIcon variant="primary" size={"lg"} text="Compare" svg={icnCompare} className="w-auto mr-0" disabled={disableCompare}/>
        );

        var result = disableCompare ? (
            <div className="compare-player">
                {Button}
            </div>
        ) : (
            <Link to="watchlist/compare-players" className="compare-player">
                {Button}
            </Link>
        );

        return result;
    };

    handleDeleteButton = (event) => {
        const {removeSelectedPlayers} = this.props;
        const deleteModal = new SA_ConfirmDelete();
        deleteModal.fire().then(result => {
            if (result.value) {
                removeSelectedPlayers();
            }
        });

        // Swal.fire({
        //     title: 'Are you sure?',
        //     text: "You won't be able to revert this!",
        //     icon: 'warning',
        //     showCancelButton: true,
        //     confirmButtonColor: '#3085d6',
        //     cancelButtonColor: '#d33',
        //     confirmButtonText: 'Yes, delete it!'
        // }).then((result) => {
        //     if (result.value) {
        //         removeSelectedPlayers();
        //     }
        // });
    };

    handleSubmit = (event) => {
        console.log(event);
    };

    handleSearchChange = event => {
        const {setSearchValue} = this.props;

        if (typeof setSearchValue == 'function') {
            setSearchValue(event.target.value);
        }
    };
}

const mapStateToProps = (state) => {
    return {
        selectedPlayers: state.watchlist.datatable.selectedPlayers,
        search: state.watchlist.search,
        tempSearch: state.watchlist.tempSearch,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setSearchValue: (value) => dispatch(setSearchValue(value)),
        removeSelectedPlayers: () => dispatch(removeSelectedPlayers()),
    };
};

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(MainToolbar));
